import React, { useEffect, useRef } from "react";
import { useViewer } from "../../../../app/hooks/hooks";
import classes from "./ClippingButton.module.css";
import { ReactComponent as IconClipping } from "../Buttons/icons/icon-clipping.svg";

function ClippingButton() {
  const viewer = useViewer();
  const clippingHandle = () => {
    if (!viewer) return;
    clickHandleRef.current = clickHandle;
    viewer.container.addEventListener("click", clickHandleRef.current);
  };
  const clickHandle = () => {
    if (!viewer) return;
    viewer.utils.clippingUtils.createPlane();
    viewer.container.removeEventListener("click", clickHandleRef.current);
  };
  const clippingContextHandle = () => {
    if (!viewer) return;
    viewer.utils.clippingUtils.deleteAllPlanes();
  };
  const clickHandleRef = useRef(clickHandle);
  useEffect(() => {
    clickHandleRef.current = clickHandle;
  }, []);
  return (
    <button
      className={classes.ClippingButton}
      onClick={clippingHandle}
      onContextMenu={clippingContextHandle}
    >
      <IconClipping className={classes.icon} />
    </button>
  );
}

export default ClippingButton;
